<template>
  <my-view></my-view>
</template>

<script>
import MyView from "@/pages/publicView/personalCenter/followBrand_view.vue";

export default {
  components: { MyView },
};
</script>